// Central multi-category catalog + imagery for Tony Rays.
const A =
    "https://customer-assets-agu9un31.emergentagent.net/job_brandship-hub/artifacts";

export const PRICE = 89;

const SOCK_IMAGES = {
    men: {
        low: {
            black: `${A}/4slz54ia_1CD5ECA3-1B0C-4D3F-9DE5-B197426BA014.png`,
            white: `${A}/61wy029p_5EA0A5A2-C258-4D50-BC17-FF74C32362BE.png`,
        },
        mid: {
            black: `${A}/rrfvrkew_image.png`,
            white: `${A}/hqg71gur_image.png`,
        },
        high: {
            black: `${A}/ou6rlboh_0605CDDD-8DCD-4F2A-ACF6-F2E5682A3595.png`,
            white: `${A}/k6kop13d_F036571A-AD3A-4E58-9CCF-4969AF50DC09.png`,
        },
    },
    women: {
        low: {
            black: `${A}/nm0gnbju_F3D7F4D8-445D-4B00-9AA0-E774CB516EFE.png`,
            white: `${A}/csa3s64t_AB348694-1A8E-41BD-9DF0-57BD0F0798F8.png`,
        },
        mid: {
            black: `${A}/wppyindr_2EDE16F6-6847-4F4D-B606-32DE525C297A.png`,
            white: `${A}/4jqyfj7j_D1DA7C23-FFC2-4011-82CF-DD11A8718E4A.png`,
        },
        high: {
            black: `${A}/kik5mr5t_image.png`,
            white: `${A}/8hovflys_image.png`,
        },
    },
};

const SOCK_BOX = {
    one: {
        black: `${A}/1guhlr78_525689EE-E54B-494E-A102-F41C9B37044E.png`,
        white: `${A}/793n8nzr_E8C4199D-5471-415B-ACB1-EF5915896390.png`,
    },
    starter: {
        black: `${A}/2x1kc3bb_DE846520-98EB-4720-A5DC-C38E199974F1.png`,
        white: `${A}/yp8mwc9k_50AFE8E3-7B04-4063-BC62-B3FE541E29C6.png`,
    },
};

// Boxer packaging (assortment shots), used only for the Starter/Assortment box.
const BOXER_ASSORT = {
    black: `${A}/5j9e6v0z_463DD918-7B07-4517-80EF-B79E19DA29F1.png`,
    white: `${A}/6h2dt0ey_image.png`,
};
// Boxer model photography (single classic style), gender-scoped.
// Rule: each tile stays color-consistent (black clothing ↔ black box, white ↔ white).
const BOXER_MODELS = {
    men: {
        classic: {
            black: `${A}/7dqdbspx_926A2783-51AB-4315-B44D-BCE6F5A74BE3.png`,
            white: `${A}/yvuecfd7_04C51AD9-B8F6-4413-9450-EC9F025AC3B1.png`,
        },
    },
    women: {
        classic: {
            black: `${A}/cbxne2rp_image.png`,
            white: `${A}/e1gi9fig_image.png`,
        },
    },
};
// One Box preview is gender-scoped; Starter Box uses the shared packaging shots.
const BOXER_BOX = {
    one: {
        men: {
            black: BOXER_MODELS.men.classic.black,
            white: BOXER_MODELS.men.classic.white,
        },
        women: {
            black: BOXER_MODELS.women.classic.black,
            white: BOXER_MODELS.women.classic.white,
        },
    },
    starter: { black: BOXER_ASSORT.black, white: BOXER_ASSORT.white },
};

// Undershirt packaging (assortment box shots).
const UNDERSHIRT_ASSORT = {
    black: `${A}/j4t1e2dm_21B12B4B-9FDD-4C24-B2A1-680B0E148611.png`,
    white: `${A}/0c8o7tpl_B148D45F-E8DE-47B7-9010-7F53E9915263.png`,
};
const UNDERSHIRT_BOX = {
    one: { black: UNDERSHIRT_ASSORT.black, white: UNDERSHIRT_ASSORT.white },
    starter: { black: UNDERSHIRT_ASSORT.black, white: UNDERSHIRT_ASSORT.white },
};

// Undershirt lifestyle composites (Crew + Tank shot together, per gender × color).
// Dedicated Tony Rays product shoot (men + women).
const UNDERSHIRT_LIFESTYLE = {
    men: {
        black: `${A}/jpvrw8w7_image.jpeg`,
        white: `${A}/7fukpl17_image.jpeg`,
    },
    women: {
        black: `${A}/1o2fmuoc_image.png`,
        white: `${A}/vpcf5o0i_image.png`,
    },
};

// Lifestyle composites (undershirt + boxer + socks + essentials box), per gender.
export const LIFESTYLE = {
    men: {
        black: `${A}/5ci6gkdz_D23B7F4A-6BD9-419C-BDAD-AF6AA328AC65.png`,
        white: `${A}/4dztkeul_EBB96653-E0D5-49BD-8173-1B9D0BAA4043.png`,
    },
    women: {
        black: `${A}/voaais5m_75C50C18-13E5-4CB9-AFB7-E414421FFD78.png`,
        white: `${A}/pfu166rw_FBC484E4-85CC-4E4D-B809-EE94D5DBF74F.png`,
    },
};

const ESSENTIAL_BOX = {
    one: {
        men: {
            black: `${A}/32pfowu6_image.png`,
            white: `${A}/5ecmgm5c_image.png`,
        },
        women: {
            black: `${A}/svoyuu6y_image.png`,
            white: `${A}/2a7xcyc9_image.png`,
        },
    },
};

export const CATEGORIES = {
    socks: {
        id: "socks",
        label: "Socks",
        noun: "socks",
        unitsPerBox: 20,
        pieceNoun: "pairs",
        assortmentBySize: false,
        hasModelPhotos: true,
        genders: ["men", "women"],
        styles: [
            { id: "low", name: "TR Low" },
            { id: "mid", name: "TR Mid" },
            { id: "high", name: "TR High" },
        ],
        styleCopy: {
            men: {
                low: "Low-cut socks designed to remain discreet inside sneakers and casual shoes.",
                mid: "The everyday length. Comfortable, versatile and easy to wear.",
                high: "A higher classic fit designed for trousers, formal shoes and colder days.",
            },
            women: {
                low: "A discreet low-cut fit designed for sneakers and everyday shoes.",
                mid: "A comfortable mid-calf fit for everyday wear.",
                high: "A knee-high fit designed to sit just below the knee.",
            },
        },
        colors: [
            { id: "black", name: "Black" },
            { id: "white", name: "White" },
        ],
        sizes: {
            men: ["EU 39-42", "EU 43-46"],
            women: ["EU 35-38", "EU 39-42"],
        },
        boxTypes: [
            { id: "one", name: "The One Box", short: "20 identical pairs of the same model and color." },
            { id: "starter", name: "The Starter Box", short: "20 assorted pairs — 5 Low / 10 Mid / 5 High." },
        ],
        assortedLabel: "Assorted",
        modelImages: SOCK_IMAGES,
        boxImages: SOCK_BOX,
    },
    boxers: {
        id: "boxers",
        label: "Boxers",
        noun: "boxers",
        unitsPerBox: 20,
        pieceNoun: "boxers",
        assortmentBySize: true,
        hasModelPhotos: false,
        singleModel: true,
        genders: ["men", "women"],
        styles: [{ id: "classic", name: "Boxer" }],
        styleCopy: {
            men: { classic: "One premium cut. Same comfort, every day." },
            women: { classic: "One premium cut. Same comfort, every day." },
        },
        colors: [
            { id: "black", name: "Black" },
            { id: "white", name: "White" },
        ],
        sizes: {
            men: ["M", "L", "XL"],
            women: ["M", "L", "XL"],
        },
        boxTypes: [
            { id: "one", name: "The One Box", short: "20 identical boxers — one color, one size." },
            { id: "starter", name: "The Assortment Box", short: "20 boxers, assorted across all sizes M to XL." },
        ],
        assortedLabel: "Assortment",
        modelImages: null,
        boxImages: BOXER_BOX,
    },
    undershirts: {
        id: "undershirts",
        label: "Undershirts",
        noun: "undershirts",
        unitsPerBox: 20,
        pieceNoun: "undershirts",
        assortmentBySize: true,
        hasModelPhotos: false,
        heroImage: UNDERSHIRT_LIFESTYLE,
        genders: ["men", "women"],
        styles: [
            { id: "crew", name: "Crew" },
            { id: "tank", name: "Tank" },
        ],
        styleCopy: {
            men: {
                crew: "The perfect invisible crew-neck tee. Same fabric, same fit, always ready.",
                tank: "A clean, close-fitting tank for layering — or wearing on its own.",
            },
            women: {
                crew: "A perfect crew-neck tee. Same fabric, same fit, always ready.",
                tank: "A clean, close-fitting tank for layering — or wearing on its own.",
            },
        },
        colors: [
            { id: "black", name: "Black" },
            { id: "white", name: "White" },
        ],
        sizes: {
            men: ["S", "M", "L", "XL", "XXL"],
            women: ["S", "M", "L", "XL", "XXL"],
        },
        boxTypes: [
            { id: "one", name: "The One Box", short: "20 identical undershirts — one model, one color, one size." },
            { id: "starter", name: "The Assortment Box", short: "20 undershirts, assorted across all sizes S to XXL." },
        ],
        assortedLabel: "Assortment",
        modelImages: null,
        boxImages: UNDERSHIRT_BOX,
    },
    essentials: {
        id: "essentials",
        label: "The Essential Box",
        noun: "essentials",
        unitsPerBox: 20,
        pieceNoun: "essentials",
        assortmentBySize: false,
        hasModelPhotos: false,
        isBundle: true,
        singleModel: true,
        contents: ["5 boxers", "5 undershirts", "10 pairs of socks"],
        lifestyle: LIFESTYLE,
        genders: ["men", "women"],
        styles: [{ id: "bundle", name: "The Essential Box" }],
        styleCopy: {
            men: { bundle: "5 boxers · 5 undershirts · 10 pairs of socks." },
            women: { bundle: "5 boxers · 5 undershirts · 10 pairs of socks." },
        },
        colors: [
            { id: "black", name: "Black" },
            { id: "white", name: "White" },
        ],
        sizes: {
            men: ["EU 39-42", "EU 43-46"],
            women: ["EU 35-38", "EU 39-42"],
        },
        apparelSizes: ["S", "M", "L", "XL", "XXL"],
        boxTypes: [
            { id: "one", name: "The Essential Box", short: "5 boxers · 5 undershirts · 10 pairs of socks." },
        ],
        assortedLabel: "Assortment",
        modelImages: null,
        boxImages: ESSENTIAL_BOX,
    },
};

export const HERO_IMAGE = SOCK_BOX.one.black;
export const getCategory = (cat) => CATEGORIES[cat] || CATEGORIES.socks;

export const styleName = (cat, id) => {
    const c = getCategory(cat);
    return c.styles.find((s) => s.id === id)?.name || "";
};
export const boxName = (cat, id) => {
    const c = getCategory(cat);
    return c.boxTypes.find((b) => b.id === id)?.name || "The One Box";
};

export const buildBreadcrumb = (cat, cfg) => {
    if (!cfg) return "";
    const c = getCategory(cat);
    const parts = [cfg.gender === "men" ? "Men" : "Women"];
    if (c.isBundle) {
        if (cfg.color) parts.push(cfg.color === "black" ? "Black" : "White");
        if (cfg.size) parts.push(cfg.size);
        return `${c.label} / ${parts.join(" / ")}`;
    }
    if (cfg.boxType === "starter") parts.push(c.assortedLabel);
    else {
        const sn = c.singleModel ? "" : styleName(cat, cfg.style);
        if (sn) parts.push(sn);
    }
    if (cfg.color) parts.push(cfg.color === "black" ? "Black" : "White");
    if (cfg.size) parts.push(cfg.size);
    parts.push(boxName(cat, cfg.boxType));
    return `${c.label} / ${parts.join(" / ")}`;
};

export const boxImage = (cat, boxType, color, gender = "men") => {
    const c = getCategory(cat);
    const node = c.boxImages[boxType];
    // Essentials use a gender-scoped structure: { one: { men: {black, white}, women: {...} } }
    if (node && node[gender] && node[gender][color]) return node[gender][color];
    // Standard flat structure: { one: { black, white } }
    return node?.[color] || c.boxImages.one?.[color] || c.boxImages.one?.men?.[color];
};

// Returns strictly the box PACKAGING shot, color-matched, for every category.
// Used on the Configurator so the user always sees the actual box they receive
// (not the model photo used for browsing on the collection page).
const BOXER_ASSORT_LOCAL = {
    black: `${A}/5j9e6v0z_463DD918-7B07-4517-80EF-B79E19DA29F1.png`,
    white: `${A}/6h2dt0ey_image.png`,
};
export const packagingImage = (cat, color, gender = "men") => {
    if (cat === "boxers") return BOXER_ASSORT_LOCAL[color];
    return boxImage(cat, "one", color, gender);
};

export const modelImage = (cat, gender, style, color) => {
    const c = getCategory(cat);
    if (c.modelImages) {
        return (
            c.modelImages[gender]?.[style]?.[color] ||
            c.modelImages[gender]?.mid?.[color]
        );
    }
    // Categories without model photography fall back to the box art.
    return boxImage(cat, "one", color, gender);
};

// Boxer minimalist glyph fallback (line icon) description by style.
export const BOXER_STYLES = CATEGORIES.boxers.styles;
